export const groupIntsIntoRanges = (strIntegers: string[]) => {
    if (!strIntegers?.length) return []

    let integers
    try {
        integers = strIntegers.map(BigInt)
    } catch (e) {
        return []
    }

    const sorted = [...new Set(integers)].sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
    })

    const ranges: string[] = []
    let start = sorted[0]
    let end = sorted[0]

    for (let i = 1; i <= sorted.length; i++) {
        if (i < sorted.length && sorted[i] === end + BigInt(1)) {
            end = sorted[i]
        } else {
            if (start === end) {
                ranges.push(start.toString())
            } else {
                ranges.push(`${start.toString()}-${end.toString()}`)
            }
            if (i < sorted.length) {
                start = sorted[i]
                end = sorted[i]
            }
        }
    }

    return ranges
}